var exports = {
  "kL": "x234b8571--f28e8a--container",
  "ld": "x234b8571--f28e8a--items",
  "nf": "x234b8571--f28e8a--link",
  "bb": "x234b8571--f28e8a--link--active",
};

module.exports = exports;
